import { useParams } from 'react-router-dom';

import { logError } from 'services/logging/logging';
import { useSupplierPublicInfo } from 'services/repositories/orderForms/orderForms';
import { cn } from 'support/helpers/cn/cn';
import { GenericError } from 'support/helpers/errors/errors';
import { PartnerLogo } from 'components/PartnerLogo/PartnerLogo';

const maxSize = {
  small: 'max-h-10 max-w-[120px] h-auto w-auto',
  large: 'max-h-20 max-w-[120px] h-auto w-auto',
};

export function SupplierLogo({ className, size = 'large' }: { className?: string; size?: 'small' | 'large' }) {
  const params = useParams<{ supplierSlug: string }>();

  const { data, isLoading } = useSupplierPublicInfo({ variables: { supplierSlug: params.supplierSlug } });

  if (!params.supplierSlug) {
    const error = new GenericError('SupplierLogo requires a supplierSlug url param', { params });
    logError(error);
    throw error;
  }

  return (
    <PartnerLogo
      fullSize
      isLoading={isLoading}
      imageUrl={data?.data?.logo_url}
      className={cn(maxSize[size], className)}
      imageClassName={cn(maxSize[size], 'object-contain')}
    />
  );
}
